module.exports = __webpack_public_path__ + "7fed8609fc09e4f73fe0d57498b01d6c.png";